const styles = theme => ({
  root: {
    width:'100%',
    marginTop: 65,
    textAlign: 'left',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Information/scenes/Search/styles.js